import { useRouter } from 'next/router';
import { YAMAZAKI_GIFT_202504_URL } from 'pages/campaign/yamazaki-gift-202504';
import React, { useContext, useState } from 'react';
import { KaimonoWebRoutes } from 'src/config/routes';
import { CLOUD_FRONT_IMAGE_PATH } from 'src/constants/imagePath';
import { useModal } from 'src/hooks/useModal';
import { I18nContext } from 'src/stores/I18n';
import { Presenter } from './Presenter';

export const IssuedCouponModal: React.FC = () => {
  const { isVisible, setIsVisible } = useModal('issuedCouponModal');
  const [step, setStep] = useState<1 | 2>(1);
  const localeResources = useContext(I18nContext);
  const { locale, pathname } = useRouter();
  const router = useRouter();
  const isCampaignPage = pathname.includes(YAMAZAKI_GIFT_202504_URL);
  const imagePath =
    isCampaignPage && step === 2
      ? `${CLOUD_FRONT_IMAGE_PATH}/common/IssuedCouponModal/campaign/${locale}.webp`
      : `${CLOUD_FRONT_IMAGE_PATH}/common/IssuedCouponModal/${locale}.webp`;
  const buttonText =
    isCampaignPage && step === 1
      ? localeResources.receive.navigation.next
      : localeResources.issuedCoupon.checkCouponNow;

  const handleStep1Next = () => setStep(2);

  const goToCartPage = () => {
    setIsVisible(false);
    setStep(1);
    router.push(`${KaimonoWebRoutes.cart}?isFromIssuedCouponModal=true`);
  };

  const handleClick = () => {
    if (isCampaignPage) {
      if (step === 1) {
        handleStep1Next();
      } else {
        goToCartPage();
      }
    } else {
      goToCartPage();
    }
  };

  if (!isVisible) return null;

  return (
    <Presenter
      buttonText={buttonText}
      localeResources={localeResources}
      imagePath={imagePath}
      onButtonClick={handleClick}
      closeModal={() => {
        setIsVisible(false);
        setStep(1);
      }}
      isCampaignPage={isCampaignPage}
      step={step}
    />
  );
};
